import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { NAVBAR_HEIGHT } from '../../constants/ui';

import * as Colors from '../../attrs/colors';

export const BrandLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  height: ${NAVBAR_HEIGHT}px;
  color: ${Colors.BLACK};
  padding: 0 2rem;
`;

export const BrandImg = styled.img`
  height: 21px;
  display: block;
`;
